<template>
  <div
    class="mb-2 border bg-white hover:shadow-lg"
    :class="{ 'shadow-lg': isOpen, 'cursor-pointer': !isOpen }"
  >
    <div class="flex items-center justify-between mr-3">
      <DealShort :deal="deal" class="flex-1" @click.native="open()" />
      <BaseDropdown icon="more-vertical" button-class="btn-icon">
        <ModalButton class="dropdown-item" label="Wijzigen">
          <DealForm
            method="patch"
            :action="`/json/contacts/${contact.id}/deals/${deal.id}`"
            :deal="deal"
            :contact="contact"
            @success="setContact"
          />
        </ModalButton>
        <DeleteConfirmButton
          class="dropdown-item w-32"
          :message="`Weet je zeker dat je deze deal wilt verwijderen?`"
          @confirm="deleteDeal()"
        >Verwijderen</DeleteConfirmButton>
      </BaseDropdown>
    </div>
    <div
      v-show="!isOpen"
      class="px-4 flex text-sm bg-blue-100 text-blue-800"
      :class="showNotesSummary ? 'py-3' : 'h-3'"
      @click="open()"
    >
      <template v-if="showNotesSummary">
        <div class="flex items-center mr-3">
          <BaseIcon name="file-text" size="16" />
          <div class="mx-1" v-if="lastActivity">
            <span class="hidden md:inline">Laatste notitie</span>
            {{ lastActivity.created_at | formatTimeAgo }}
          </div>
          <div class="mx-1 hidden md:block" v-else>Nog geen notities</div>
        </div>
        <div v-if="firstReminder" class="flex items-center">
          <BaseIcon name="clock" size="16" />
          <div class="mx-1">
            <span class="hidden md:inline">Reminder op</span>
            {{ firstReminder.reminder_at | formatDay }}
          </div>
        </div>
      </template>
    </div>
    <div v-show="isOpen" class="py-3 px-4 border-t border-gray-300">
      <div class="flex items-center justify-end" v-if="isOpen">
        <div class="flex-1 text-sm text-gray-500">Notities &amp; Reminders bij deze deal</div>
        <button @click.stop="isOpen = false">
          <BaseIcon name="x" />
        </button>
      </div>
    </div>
    <div v-show="isOpen" class="p-4 border-t border-gray-300">
      <ModalButton class="btn btn-blue-light flex items-center px-3 w-full">
        <template v-slot:button>
          <BaseIcon name="file-text" size="16" class="mr-2" />Nieuwe notitie toevoegen
        </template>
        <NoteForm
          :action="`/json/contacts/${contact.id}/notes`"
          :deal="deal"
          @success="setContact"
        />
      </ModalButton>
      <div class="px-3">
        <h3
          class="py-2 my-3 text-sm border-b border-gray-200"
          v-if="reminders.length"
        >Notities met reminder</h3>
        <NoteReminder
          v-for="note in reminders"
          :contact="contact"
          :note="note"
          :key="note.id"
          class="mt-2 mb-4"
        />
        <h3 class="py-2 my-3 text-sm border-b border-gray-200" v-if="activities.length">Notities</h3>
        <ActivityList :activities="activities" :showAll="showAllActivities" subtle />
      </div>
    </div>
  </div>
</template>

<script>
import { destroy } from "@/api";
import DealForm from "./DealForm";
import DealShort from "./DealShort";
import DeleteConfirmButton from "./DeleteConfirmButton";
import ActivityList from "./ActivityList";
import NoteForm from "./NoteForm";
import NoteReminder from "./NoteReminder";

export default {
  props: {
    deal: {
      type: Object,
      required: true
    },
    contact: {
      type: Object,
      required: true
    }
  },

  components: {
    DealForm,
    DealShort,
    DeleteConfirmButton,
    ActivityList,
    NoteForm,
    NoteReminder
  },

  data() {
    return {
      isOpen: false,
      showAllActivities: false
    };
  },

  computed: {
    showNotesSummary() {
      let isPending = this.deal.result == "pending";

      return isPending && (this.lastActivity || this.firstReminder);
    },

    activities() {
      return this.contact.activities.filter(
        a => a.subject && a.subject.deal_id === this.deal.id && a.is_visible
      );
    },

    lastActivity() {
      return this.contact.activities.filter(
        a => a.subject && a.subject.deal_id === this.deal.id
      )[0];
    },

    firstReminder() {
      return this.reminders[0];
    },

    reminders() {
      return this.contact.reminders.filter(r => r.deal_id === this.deal.id);
    }
  },

  methods: {
    open() {
      this.isOpen = true;
    },

    setContact(data) {
      this.$store.commit("SET_CONTACT", data);
    },

    deleteDeal() {
      let contact = this.$store.state.contact;
      let deal = this.deal;

      destroy(`/contacts/${contact.id}/deals/${deal.id}`).then(response => {
        this.$store.commit("SET_CONTACT", response.data);
        this.$store.commit("FLASH_ADD", { message: "Deal is verwijderd" });
      });
    }
  }
};
</script>
